import { UpdateSchoolJobFamilyForm } from 'types/dacum/schoolManagement';
import { create } from 'zustand';

type Mode = 'add' | 'edit' | 'view';

interface SchoolJobFamilyState {
  formData: UpdateSchoolJobFamilyForm;
  mode: Mode;
  setFormData: (_data: Partial<UpdateSchoolJobFamilyForm>) => void;
  setMode: (_data: Mode) => void;
  reset: () => void;
}

export const useSchoolJobFamilyStore = create<SchoolJobFamilyState>((set) => ({
  formData: {
    msSchoolCompetencyManagementID: '',
    jobFamilyID: '',
    trSchoolJobFamilyID: ''
  },
  mode: 'add',
  setFormData: (data) =>
    set((state) => ({
      formData: { ...state.formData, ...data }
    })),
  setMode: (data) => set(() => ({ mode: data })),
  reset: () =>
    set({
      formData: {
        msSchoolCompetencyManagementID: '',
        jobFamilyID: '',
        trSchoolJobFamilyID: ''
      },
      mode: 'add'
    })
}));
